<script setup lang="ts">
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { ref, type Ref } from 'vue';
import KpJahrSelect from './KpJahrSelect.vue';
import KpMandantKantonSelect from './KpMandantKantonSelect.vue';
const value: Ref<any> = defineModel();

const { withFromYear = false } = defineProps<{ withFromYear?: boolean }>();

const emit = defineEmits(['copy']);

const sourceJahr: Ref<number | null> = ref(null);
const targetJahr: Ref<number | null> = ref(null);
const kanton: Ref<number | null> = ref(null);

function onCopy() {
    value.value = false;
    emit('copy', targetJahr.value, kanton.value, sourceJahr.value);
}
</script>

<template>
    <Dialog
        v-model:visible="value"
        modal
        :header="$t('eintraege_kopieren')"
        :draggable="false"
        :style="{ width: '25rem' }"
    >
        <div v-if="withFromYear">
            <span class="text-surface-500 dark:text-surface-400 block mt-2rem mb-1_5rem">{{
                $t('welches_quell_jahr_ohne_alle')
            }}</span>
            <KpJahrSelect v-model="sourceJahr" fluid></KpJahrSelect>
        </div>
        <span class="text-surface-500 dark:text-surface-400 block mt-2rem mb-1_5rem">{{
            $t('welches_ziel_jahr')
        }}</span>
        <KpJahrSelect v-model="targetJahr" fluid></KpJahrSelect>
        <span class="text-surface-500 dark:text-surface-400 block mt-2rem mb-1_5rem">{{ $t('ziel_kanton') }}</span>
        <KpMandantKantonSelect v-model="kanton" fluid></KpMandantKantonSelect>
        <div class="flex justify-content-end gap-2">
            <Button type="button" :label="$t('abbrechen')" severity="secondary" @click="value = false"></Button>
            <Button
                :disabled="(withFromYear && !sourceJahr) || !targetJahr || !kanton"
                type="button"
                :label="$t('kopieren')"
                severity="success"
                @click="onCopy"
            ></Button>
        </div>
    </Dialog>
</template>
